import { theme } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import { AddPeopleIcon, CreditCardIcon, PermissionIcon, QuickActionsIcon, RemoteUnlockIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';
import {
	AddCredentialModal,
	AddGuestModal,
	AddPeopleModal,
	GrantPermissionsModal,
	RemoteUnlockModal
} from 'zComponents/molecules';
import { Button, Dropdown, Flex, Typography } from 'zui/Antd';
const { Title } = Typography;

const ActionsTopbarDropdown = () => {
	const {
		token: { colorBgContainer, colorTextLabel, boxShadow, borderRadiusLG, paddingMD, paddingSM, fontWeightStrong }
	} = theme.useToken();

	// ✅ Permissions
	const canManagePermissions = useManagePermittedRoles('aCPermissionManagement');
	const canAddPerson = useManagePermittedRoles('addPerson');
	const canAddCredential = useManagePermittedRoles('addCredential');
	const canRemoteUnlock = useManagePermittedRoles('aCRemoteUnlock');

	// ✅ Local State
	const [openDropdown, setOpenDropdown] = useState(false);

	const items = [
		{
			key: 'addGuest',
			label: (
				<AddGuestModal>
					<Button
						icon={<UserAddOutlined />}
						iconPosition='start'
						block
						disabled={!canManagePermissions}
						style={{ justifyContent: 'flex-start' }}
					>
						Add Guest
					</Button>
				</AddGuestModal>
			)
		},
		{
			key: 'addPeople',
			label: (
				<AddPeopleModal>
					<Button
						icon={<AddPeopleIcon color='currentColor' />}
						iconPosition='start'
						block
						disabled={!canAddPerson}
						style={{ justifyContent: 'flex-start' }}
					>
						Add People
					</Button>
				</AddPeopleModal>
			)
		},
		{
			key: 'addCredential',
			label: (
				<AddCredentialModal>
					<Button
						icon={<CreditCardIcon color='currentColor' />}
						iconPosition='start'
						block
						disabled={!canAddCredential}
						style={{ justifyContent: 'flex-start' }}
					>
						Add Credential
					</Button>
				</AddCredentialModal>
			)
		},
		{
			key: 'grantPermission',
			label: (
				<GrantPermissionsModal>
					<Button
						icon={<PermissionIcon color='currentColor' />}
						iconPosition='start'
						block
						disabled={!canManagePermissions}
						style={{ justifyContent: 'flex-start' }}
					>
						Grant Permission
					</Button>
				</GrantPermissionsModal>
			)
		},
		{
			key: 'remoteUnlock',
			label: (
				<RemoteUnlockModal>
					<Button
						icon={<RemoteUnlockIcon color='currentColor' />}
						iconPosition='start'
						block
						disabled={!canRemoteUnlock}
						style={{ justifyContent: 'flex-start' }}
					>
						Remote Unlock
					</Button>
				</RemoteUnlockModal>
			)
		}
	];

	return (
		<Dropdown
			arrow
			placement='bottom'
			menu={{ items }}
			trigger={['click']}
			open={openDropdown}
			onOpenChange={setOpenDropdown}
			dropdownRender={() => (
				<Flex
					style={{
						backgroundColor: colorBgContainer,
						borderRadius: borderRadiusLG,
						width: 272,
						boxShadow: boxShadow,
						padding: `${paddingMD}px 0px ${paddingMD}px`
					}}
					vertical
					gap={12}
				>
					<Title
						level={5}
						style={{
							textAlign: 'center',
							margin: 0
						}}
						color={colorTextLabel}
					>
						Quick Actions
					</Title>

					{items.map((item) => (
						<div
							key={item.key}
							onClick={() => setOpenDropdown(false)}
							style={{
								padding: `0px ${paddingSM}px`
							}}
						>
							{item.label}
						</div>
					))}
				</Flex>
			)}
		>
			<Button icon={<QuickActionsIcon color='currentColor' />} style={{ fontWeight: fontWeightStrong }}>
				Quick Actions
			</Button>
		</Dropdown>
	);
};

export default ActionsTopbarDropdown;
